import { Ability } from '@casl/ability';
import { Cookie } from 'src/utility/Cookie';
import { CookieKeys } from 'src/utility/Constant';
import { AdminAbility, ReadOnlyAbility } from './abilityConfig';

//  Read ability from localStorage
// * Handles auto fetching previous abilities if already logged in user
// ? You can update this if you store user abilities to more secure place
// ! Anyone can update localStorage so be careful and please update this

const user = Cookie.getItem(CookieKeys.user) || {};


/* const userData = JSON.parse(localStorage.getItem('userData'));
const existingAbility = userData ? userData.ability : null; */

export default new Ability((user?.roles || []).includes('ReadOnly') ? ReadOnlyAbility : AdminAbility);
